import { Card, CardContent, CardHeader } from '@optools/components/ui/card';
import { Separator } from '@optools/components/ui/separator';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@optools/components/ui/sheet';
import { UserPlaybackSession } from '@optools/services/operator-gateway/user-lookup/types';
import { formatFullDateAndTimeUTC } from '@optools/utils/datetime';

import { CardField } from './card-field';

export interface PlaybackSessionSheetProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  playbackSessions: UserPlaybackSession[];
}

export function PlaybackSessionsSheet({
  onOpenChange,
  open,
  playbackSessions,
}: PlaybackSessionSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle className="flex flex-wrap items-center gap-6">Playback Sessions</SheetTitle>
          <SheetDescription className="sr-only">Users playback sessions</SheetDescription>
          <Separator className="mt-4" />
        </SheetHeader>
        <div className="mt-8 flex w-full flex-col gap-2 overflow-auto">
          {playbackSessions?.map((session) => {
            return (
              <Card
                key={session.playbackSessionId}
                className="flex min-w-max flex-col gap-2 p-4"
                data-testid={`playback-session-${session.playbackSessionId}`}>
                <CardHeader className="p-0">
                  <div className="flex gap-1 p-0">
                    <span className="font-bold">Playback Session ID:</span>
                    <span>{session.playbackSessionId}</span>
                  </div>
                </CardHeader>
                <CardContent className="border-box mt-2 flex max-h-20 w-full flex-col flex-wrap gap-1 p-0">
                  <CardField
                    label="Create Time"
                    value={formatFullDateAndTimeUTC(session.createTime.replace('[UTC]', ''))}
                  />
                  <CardField
                    label="Counts For Cap"
                    value={session.countsForCap.toString().toLocaleUpperCase()}
                  />
                  <CardField label="Media ID" value={session.mediaId} />
                  <CardField label="Content Experience" value={session.contentExperience} />
                  <CardField label="Playback Status" value={session.playbackStatus} />
                  <CardField label="Entitlements" value={session.entitlements.join(', ')} />
                  <CardField label="Features" value={session.features.join(', ')} />
                </CardContent>
              </Card>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
